export enum POPUP_ALERT_TYPES {
    DANGER = 'DANGER',
    INFO = 'INFO'
}